import React from "react";

interface DataFieldProps {
  label: string | null;
  quantity?: number | null;
  power: number | null;
  unit: string | null;
}

const StatisticField: React.FC<DataFieldProps> = ({ label, quantity, power, unit }) => {
  return (
    <div className="flex flex-col justify-center items-center text-center">
      <div className="text-[#6d6f7d] text-[14px] font-medium font-montserrat">
        {label}
      </div>
      <div className="text-[#303139] text-[18px] font-semibold font-montserrat">
        {quantity ? `${quantity} de ${power} ${unit}` : `${power} ${unit}`}
      </div>
    </div>
  );
};

export default StatisticField;
